module.exports = __webpack_public_path__ + "media/images/banner/coupons/coupon-ko-a5eec6cdba993692a15a3fc043f886d5.png";